export const arce = (state) => state.arce